import { handleDayOfMonth, handleMonthString } from "../../../utils/Functions";
import { Appointment } from "../../appointments/types/Appointment";

export const getDisplayDate = (consult: Appointment) => {
    const appointmentDate = new Date(consult.date);
    const today = new Date();
    const dayDiff = (appointmentDate.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0)) / (1000 * 3600 * 24);

    return dayDiff === 0 ? "Oggi" : dayDiff === 1 ? "Domani" : `${handleDayOfMonth(consult.date)} ${handleMonthString(consult.date)}`;
};